import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    matchesCount: {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0,
      width: 19,
      height: 19,
      backgroundColor: primary.main,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 11,
      color: theme.palette.common.white,
      borderRadius: "50%",
      marginRight: 6,
      "&.selected": {
        color: secondary.main
      },
      "&.disabled": {
        backgroundColor: "#eee",
        color: primary.light
      }
    }
  };
});
